export enum KeyCode {
    
    Enter = 13,
    Escape = 27
}
